const pageSelectSlider = document.querySelector(".js-pg-select-slider"),
      pageSelectGoButton = document.querySelector(".js-page-select-go-btn");

let thisPageNumber = body.dataset.pageno,
    pageSelectInitialIndex = thisPageNumber - 1;


if (typeof pageSelectSlider != "undefined" && pageSelectSlider != null) {

    const flkty = new Flickity(pageSelectSlider, {
        cellAlign: "center",
        prevNextButtons: false,
        pageDots: false,
        draggable: true,
        imagesLoaded: true,
        setGallerySize: true,
        initialIndex: pageSelectInitialIndex,
        resize: true,
        wrapAround: false,
        on: {
            ready: function() {
                let activeSlide = pageSelectSlider.querySelector(".js-page-select-slide.is-selected");
                let activeBtn = activeSlide.querySelector(".js-page-select-btn");
                let urlToPass = activeBtn.dataset.url;
                
                //update go button url
                pageSelectGoButton.setAttribute("href", urlToPass);
            },
            change: function() {
                let activeSlide = pageSelectSlider.querySelector(".js-page-select-slide.is-selected");
                let activeBtn = activeSlide.querySelector(".js-page-select-btn");
                let urlToPass = activeBtn.dataset.url;
        
                //update go button url
                pageSelectGoButton.setAttribute("href", urlToPass);
            }
        }
    });

    flkty.on( 'staticClick', function( event, pointer, cellElement, cellIndex ) {
        if ( typeof cellIndex == 'number' ) {
          flkty.selectCell( cellIndex );
        }
    });
}